export const IMAGE_UPLOAD_DATE = "imageUploadDate";
export const ANNOTATION_LAST_EDITED_DATE = "annotationLastEdited";
